const _jsxFileName = '';
import React, { useEffect } from 'react';
import { Shield, Lock, Eye, FileText, ArrowLeft, Server, Globe } from 'lucide-react';

const PrivacyPolicy = ({ onNavigate }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return React.createElement(
    'div',
    {
      className: 'bg-stone-50 min-h-screen pt-32 pb-20',
      __self: this,
      __source: { fileName: _jsxFileName, lineNumber: 15 },
    },
    React.createElement(
      'div',
      {
        className: 'max-w-4xl mx-auto px-6',
        __self: this,
        __source: { fileName: _jsxFileName, lineNumber: 16 },
      },

      /* Navigation */
      React.createElement(
        'button',
        {
          onClick: () => onNavigate('home'),
          className:
            'flex items-center gap-2 text-stone-500 hover:text-stone-900 text-xs uppercase tracking-widest mb-8 transition-colors',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 19 },
        },

        React.createElement(ArrowLeft, {
          size: 14,
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 23 },
        }),
        ' Back to Home'
      ),

      /* Header */
      React.createElement(
        'div',
        {
          className:
            'bg-white border border-stone-200 p-10 md:p-16 shadow-sm mb-8 relative overflow-hidden',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 27 },
        },
        React.createElement('div', {
          className:
            'absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-gold-300 via-gold-500 to-gold-300',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 28 },
        }),
        React.createElement(
          'div',
          {
            className: 'absolute -right-10 -top-10 text-stone-50 opacity-50 transform rotate-12',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 29 },
          },
          React.createElement(Shield, {
            size: 200,
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 30 },
          })
        ),

        React.createElement(
          'div',
          {
            className: 'relative z-10',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 33 },
          },
          React.createElement(
            'span',
            {
              className: 'text-gold-600 text-xs tracking-[0.3em] uppercase font-bold mb-4 block',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 34 },
            },
            'Legal & Compliance'
          ),
          React.createElement(
            'h1',
            {
              className: 'font-serif text-4xl md:text-5xl text-stone-900 mb-6',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 35 },
            },
            'Privacy Policy'
          ),
          React.createElement(
            'p',
            {
              className: 'text-stone-500 font-light text-sm',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 36 },
            },
            'Last Updated: October 24, 2026'
          )
        )
      ),

      /* Content Body */
      React.createElement(
        'div',
        {
          className:
            'bg-white border border-stone-200 p-10 md:p-16 shadow-sm space-y-12 text-stone-700 leading-relaxed font-light',
          __self: this,
          __source: { fileName: _jsxFileName, lineNumber: 41 },
        },

        React.createElement(
          'section',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 43 } },
          React.createElement(
            'h2',
            {
              className: 'font-serif text-2xl text-stone-900 mb-4 flex items-center gap-3',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 44 },
            },
            React.createElement(Shield, {
              className: 'text-gold-600',
              size: 20,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 45 },
            }),
            ' 1. Our Commitment'
          ),
          React.createElement(
            'p',
            {
              className: 'mb-4',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 47 },
            },
            'At Sparkling Gems, we are committed to maintaining the trust and confidence of our visitors to our web site. In this Privacy Policy, we’ve provided detailed information on when and why we collect your personal information, how we use it, the limited conditions under which we may disclose it to others and how we keep it secure.'
          ),
          React.createElement(
            'p',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 50 } },
            'We treat your personal data with the same care and respect as we do the rare gemstones in our vault. Your privacy is a luxury we intend to protect.'
          )
        ),

        React.createElement(
          'section',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 55 } },
          React.createElement(
            'h2',
            {
              className: 'font-serif text-2xl text-stone-900 mb-4 flex items-center gap-3',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 56 },
            },
            React.createElement(Eye, {
              className: 'text-gold-600',
              size: 20,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 57 },
            }),
            ' 2. Information We Collect'
          ),
          React.createElement(
            'p',
            {
              className: 'mb-4',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 59 },
            },
            'We collect information that you voluntarily provide to us when you:'
          ),
          React.createElement(
            'ul',
            {
              className: 'list-disc pl-6 space-y-2 mb-4 marker:text-gold-500',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 62 },
            },
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 63 } },
              'Register for a Member account.'
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 64 } },
              'Purchase products or services (Shipping address, payment details).'
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 65 } },
              'Contact our Concierge team for bespoke inquiries.'
            ),
            React.createElement(
              'li',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 66 } },
              'Subscribe to our newsletter or waitlists.'
            )
          ),
          React.createElement(
            'p',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 68 } },
            React.createElement(
              'strong',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 69 } },
              'Automated Data:'
            ),
            ' When you visit our site, we automatically collect certain information about your device, including information about your web browser, IP address, time zone, and some of the cookies that are installed on your device.'
          )
        ),

        React.createElement(
          'section',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 73 } },
          React.createElement(
            'h2',
            {
              className: 'font-serif text-2xl text-stone-900 mb-4 flex items-center gap-3',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 74 },
            },
            React.createElement(FileText, {
              className: 'text-gold-600',
              size: 20,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 75 },
            }),
            ' 3. How We Use Your Information'
          ),
          React.createElement(
            'div',
            {
              className: 'grid grid-cols-1 md:grid-cols-2 gap-6 mt-6',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 77 },
            },
            React.createElement(
              'div',
              {
                className: 'bg-stone-50 p-6 rounded-sm border border-stone-100',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 78 },
              },
              React.createElement(
                'h3',
                {
                  className: 'font-bold text-stone-900 text-sm uppercase tracking-wide mb-2',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 79 },
                },
                'Order Fulfillment'
              ),
              React.createElement(
                'p',
                {
                  className: 'text-xs',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 80 },
                },
                'To process transactions, arrange for shipping, provide invoices and order confirmations, and handle returns.'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'bg-stone-50 p-6 rounded-sm border border-stone-100',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 82 },
              },
              React.createElement(
                'h3',
                {
                  className: 'font-bold text-stone-900 text-sm uppercase tracking-wide mb-2',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 83 },
                },
                'Concierge Services'
              ),
              React.createElement(
                'p',
                {
                  className: 'text-xs',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 84 },
                },
                'To communicate with you, verify identity for high-value transactions, and provide personalized jewelry recommendations.'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'bg-stone-50 p-6 rounded-sm border border-stone-100',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 86 },
              },
              React.createElement(
                'h3',
                {
                  className: 'font-bold text-stone-900 text-sm uppercase tracking-wide mb-2',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 87 },
                },
                'Security'
              ),
              React.createElement(
                'p',
                {
                  className: 'text-xs',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 88 },
                },
                'To screen our orders for potential risk or fraud and ensure the integrity of our member platform.'
              )
            ),
            React.createElement(
              'div',
              {
                className: 'bg-stone-50 p-6 rounded-sm border border-stone-100',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 90 },
              },
              React.createElement(
                'h3',
                {
                  className: 'font-bold text-stone-900 text-sm uppercase tracking-wide mb-2',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 91 },
                },
                'Improvement'
              ),
              React.createElement(
                'p',
                {
                  className: 'text-xs',
                  __self: this,
                  __source: { fileName: _jsxFileName, lineNumber: 92 },
                },
                'To analyze site usage and improve our inventory selection and digital experience.'
              )
            )
          )
        ),

        React.createElement(
          'section',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 97 } },
          React.createElement(
            'h2',
            {
              className: 'font-serif text-2xl text-stone-900 mb-4 flex items-center gap-3',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 98 },
            },
            React.createElement(Lock, {
              className: 'text-gold-600',
              size: 20,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 99 },
            }),
            ' 4. Data Security'
          ),
          React.createElement(
            'p',
            {
              className: 'mb-4',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 101 },
            },
            'We use industry-standard Secure Socket Layer (SSL) encryption to protect the confidentiality of your personal information. Payment information is handled by PCI-DSS compliant providers and is never stored in plain text on our servers.'
          ),
          React.createElement(
            'div',
            {
              className:
                'flex items-center gap-2 text-xs text-stone-500 bg-stone-100 p-3 inline-block rounded-sm',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 104 },
            },
            React.createElement(Server, {
              size: 14,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 105 },
            }),
            ' Data is stored in secure, access-controlled data centers.'
          )
        ),

        React.createElement(
          'section',
          { __self: this, __source: { fileName: _jsxFileName, lineNumber: 109 } },
          React.createElement(
            'h2',
            {
              className: 'font-serif text-2xl text-stone-900 mb-4 flex items-center gap-3',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 110 },
            },
            React.createElement(Globe, {
              className: 'text-gold-600',
              size: 20,
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 111 },
            }),
            ' 5. Third-Party Sharing'
          ),
          React.createElement(
            'p',
            { __self: this, __source: { fileName: _jsxFileName, lineNumber: 113 } },
            'We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing you (e.g., armored courier services), so long as those parties agree to keep this information confidential.'
          )
        ),

        React.createElement(
          'section',
          {
            className: 'border-t border-stone-200 pt-8 mt-8',
            __self: this,
            __source: { fileName: _jsxFileName, lineNumber: 118 },
          },
          React.createElement(
            'h2',
            {
              className: 'font-serif text-xl text-stone-900 mb-2',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 119 },
            },
            'Contact the Data Privacy Officer'
          ),
          React.createElement(
            'p',
            {
              className: 'mb-4 text-sm',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 120 },
            },
            'If you have questions regarding this privacy policy or wish to exercise your rights to data access or deletion, please contact us.'
          ),
          React.createElement(
            'div',
            {
              className: 'flex flex-col gap-1 text-sm font-medium text-stone-800',
              __self: this,
              __source: { fileName: _jsxFileName, lineNumber: 123 },
            },
            React.createElement(
              'span',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 124 } },
              'Sparkling Gems Philippines'
            ),
            React.createElement(
              'span',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 125 } },
              'Attn: Privacy Officer'
            ),
            React.createElement(
              'span',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 126 } },
              'Unit 88, Luxury Lane, Ayala Avenue'
            ),
            React.createElement(
              'span',
              { __self: this, __source: { fileName: _jsxFileName, lineNumber: 127 } },
              'Makati City, 1200'
            ),
            React.createElement(
              'a',
              {
                href: 'mailto:privacy@sparklinggems.ph',
                className: 'text-gold-600 hover:underline mt-2',
                __self: this,
                __source: { fileName: _jsxFileName, lineNumber: 128 },
              },
              'privacy@sparklinggems.ph'
            )
          )
        )
      )
    )
  );
};

export default PrivacyPolicy;
